import Vue from "vue";
// eslint-disable-next-line no-unused-vars
import router from "../../router";
//import store from '..';
// import {
//     store
// } from '../../store/index'

const state = {
	status: "",
	supplier_token: localStorage.getItem("supplier_token") || "",
	supplier_name: localStorage.getItem("supplier_name") || "",
	supplier_type: localStorage.getItem("supplier_type") || "",
	customer: {
		first_surety_id:
			localStorage.getItem("suppliersCustomerFirstSuretyID") || "",
		second_surety_id:
			localStorage.getItem("suppliersCustomerSecondSuretyID") || "",
		first_name: localStorage.getItem("suppliersCustomerFirstName") || "",
		last_name: localStorage.getItem("suppliersCustomerLastName") || "",
	},
};

const getters = {
	// GetUserMobileNumber(state) {
	//     return state.customer.user.mobile_number;
	// },
	getSupplierName(state) {
		return state.supplier_name;
	},

	getSuppliersCustomerFirstSuretyID(state) {
		return state.customer.first_surety_id;
	},

	getSuppliersCustomerSecondSuretyID(state) {
		return state.customer.second_surety_id;
	},

	getSuppliersCustomerFirstName(state) {
		return state.customer.first_name;
	},
	getSuppliersCustomerLastName(state) {
		return state.customer.last_name;
	},
	getSupplierType(state) {
		return state.supplier_type;
	},
	isSupplierLoggedIn: (state) => !!state.supplier_token,
	supplierAuthStatus: (state) => state.status,
};

const mutations = {
	auth_request(state) {
		state.status = "loading";
	},
	supplier_auth_success(state, token) {
		state.status = "success";
		state.supplier_token = token;
	},
	auth_error(state) {
		state.status = "error";
	},
	supplierLogout(state) {
		state.status = "";
		state.supplier_token = "";
		state.supplier_name = "";
		state.customer.first_surety_id = "";
		state.customer.second_surety_id = "";
		state.first_name = "";
		state.last_name = "";
	},

	setSupplierName(state, supplier_name) {
		state.supplier_name = supplier_name;
	},

	setSuppliersCustomerFirstSurety(state, first_surty_id) {
		state.customer.first_surety_id = first_surty_id;
	},

	setSuppliersCustomerSecondSurety(state, second_surty_id) {
		state.customer.second_surety_id = second_surty_id;
	},

	setSuppliersCustomerFirstName(state, first_name) {
		state.customer.first_name = first_name;
	},
	setSuppliersCustomerLastName(state, last_name) {
		state.customer.last_name = last_name;
	},
	setSupplierType(state, supplier_type) {
		state.supplier_type = supplier_type;
	},

	// SetMobileNumber(state, mobileNumber) {
	//     state.customer.user.mobile_number = mobileNumber;
	// },
};

const actions = {
	loginSupplier(context, loginData) {
		return new Promise((resolve, reject) => {
			// context.dispatch("logOut")
			Vue.http
				.post("login/", loginData)
				.then((response) => {
					context.commit("auth_request");
					if (response.status === 200 && "access" in response.body) {
						// store._vm.$session.start();
						// this.$session.set("jwt", response.body.access);
						const token = response.body.access;
						// const user = resp.data.user
						localStorage.setItem("supplier_token", token);
						state.token = token
						Vue.http.headers.common["Authorization"] = "Bearer " + token;
						// Vue.http.headers.common["Access-Control-Allow-Origin"] = "http://localhost:8080";

						context.commit("supplier_auth_success", token);

						resolve(response);
					}
				})
				.catch((err) => {
					context.commit("auth_error", err);
					localStorage.removeItem("supplier_token");
					reject(err);
				});
		});
	},

	suppliersCustomerGetOtp(context, mobileNumber) {
		// context.dispatch("supplierLogout")
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/otp/", mobileNumber)
				.then((response) => {
					// localStorage.setItem("mobile_number", response.body.mobile_number);
					resolve(response);
				})
				.catch((err) => {
					console.log(err);
					// state.commit('auth_error', err)
					reject(err);
				});
		});
	},
	suppliersCustomerCheckOtp(context, otp) {
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/otp/", otp)
				.then((response) => {
					// localStorage.setItem("otp_code", "ok");
					resolve(response);
				})
				.catch((err) => {
					context.commit("auth_error", err);
					reject(err);
				});
		});
	},
	suppliersCustomerResentOtp(context, mobile_number) {
		return new Promise((resolve, reject) => {
			let url = "api/registration/otp/" + "?mobile_number=" + mobile_number;
			Vue.http
				.get(url)
				.then((response) => {
					// localStorage.setItem("otp_code", "ok");
					resolve(response);
				})
				.catch((err) => {
					context.commit("auth_error", err);
					reject(err);
				});
		});
	},
	// eslint-disable-next-line no-unused-vars
	suppliersCustomerBaseRegister(context, baseData) {
		return new Promise((resolve, reject) => {
			delete Vue.http.headers.common["Authorization"];
			Vue.http
				.post("users/", baseData)
				.then((response) => {
					// localStorage.setItem("first_name", response.body.user.first_name);
					// localStorage.setItem("last_name", response.body.user.last_name);
					// context.commit("setFirstName", response.body.user.first_name);
					// context.commit("setLastName", response.body.user.last_name);
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	supplierRegister(context, supplierData) {
		return new Promise((resolve, reject) => {
			delete Vue.http.headers.common["Authorization"];
			Vue.http
				.post("api/supplier/registration/", supplierData)
				.then((response) => {
					console.log(response);
					resolve(response);
				})
				.catch((err) => {
					console.log(err);

					reject(err);
				});
		});
	},

	// getForgotPassOtp(context, mobileNumber) {
	//     return new Promise((resolve, reject) => {
	//         Vue.http
	//             .post("api/registration/reset_password",
	//                 mobileNumber
	//             )
	//             .then(response => {

	//                 localStorage.setItem("mobile_number", response.body.mobile_number);
	//                 resolve(response)

	//             }).catch(err => {
	//                 console.log(err)
	//                 // state.commit('auth_error', err)
	//                 reject(err)
	//             });
	//     })
	// },

	getSupplierInfo(context) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/supplier/supplier", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					localStorage.setItem("supplier_name", response.body.name);
					localStorage.setItem("supplier_type", response.body.Type);
					
					context.commit("setSupplierName", response.body.name);
					context.commit("setSupplierType", response.body.Type);
					resolve(response);
				})
				.catch((err) => {
					console.log(err);
					// state.commit('auth_error', err)
					reject(err);
				});
		});
	},

	getSupplierCustomers() {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/supplier/customers/", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateSupplierUser(context, user_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.patch("users/me/", user_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					console.log(response);
					resolve(response);
				})
				.catch((err) => {
					console.log(err);
					localStorage.removeItem("supplier_token");
					reject(err);
				});
		});
	},
	getSuppliersCustomer(context, customerID) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/registration/customer/?customerID=" + customerID, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
					console.log("-------------------------------------------------"+ response.body.surtys)
					context.commit(
						"setSuppliersCustomerFirstSurety",
						response.body.surteys[0],
					);
					context.commit(
						"setSuppliersCustomerSecondSurety",
						response.body.surteys[1],
					);
					localStorage.setItem(
						"suppliersCustomerFirstSuretyID",
						response.body.surteys[0],
					);
					localStorage.setItem(
						"suppliersCustomerSecondSuretyID",
						response.body.surteys[1],
					);
					context.commit(
						"setSuppliersCustomerFirstName",
						response.body.user.first_name,
					);
					context.commit(
						"setSuppliersCustomerLastName",
						response.body.user.last_name,
					);
					localStorage.setItem(
						"suppliersCustomerFirstName",
						response.body.user.first_name,
					);
					localStorage.setItem(
						"suppliersCustomerLastName",
						response.body.user.last_name,
					);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	addCustomer(context, customer_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/customer/", customer_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateSuppliersCustomer(context, customerData) {
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/customer/", customerData, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	createSupplierCustomerDocs(context, docs) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/document/customer/", docs, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSupplierCustomerDocs() {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/document/customer/?customer="+ localStorage.getItem("SupplierCustomerId"), {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateSupplierCustomerDocs(context, docs) {

		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/document/customer/", docs, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getSuppliersCustomerSurety(context, ID) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get(
					"api/registration/surety/?customerID=" +
						ID.customerID +
						"&suretyID=" +
						ID.suretyID,
					{
						headers: {
							Authorization: "Bearer " + localStorage.getItem("customer_token"),
						},
					},
				)
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	createSuppliersCustomerSurety(context, surty_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/registration/surety/", surty_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateSuppliersCustomerSurety(context, surty_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/registration/surety/", surty_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getSuppliersCustomerSuretyDocs() {
		return new Promise((resolve, reject) => {
			let path=""
			let suppliersCustomerFirstSuretyID=localStorage.getItem("suppliersCustomerFirstSuretyID")
			let suppliersCustomerSecondSuretyID=localStorage.getItem("suppliersCustomerSecondSuretyID")

			if(suppliersCustomerFirstSuretyID)
			{
				path="api/document/customer/?customer=" +suppliersCustomerFirstSuretyID
			}
			else if(suppliersCustomerSecondSuretyID)
			{
				path="api/document/customer/?customer=" + suppliersCustomerSecondSuretyID
			}

			Vue.http
				.get(
					path,
						
						
					{
						headers: {
							Authorization: "Bearer " + localStorage.getItem("customer_token"),
						},
					},
				)
				.then((resp) => {
					console.log(resp);
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	createSupplierSurtyDocs(context, surtyDocs) {
		
			
			
			
			
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/document/customer/", surtyDocs, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	updateSupplierSuretyDocs(context, surtyDocs) {
		let suppliersCustomerFirstSuretyID=localStorage.getItem("suppliersCustomerFirstSuretyID")
			let suppliersCustomerSecondSuretyID=localStorage.getItem("suppliersCustomerSecondSuretyID")

			if(suppliersCustomerFirstSuretyID)
			{
				surtyDocs.customer = suppliersCustomerFirstSuretyID
			}
			else if(suppliersCustomerSecondSuretyID)
			{
			
				surtyDocs.customer = suppliersCustomerSecondSuretyID
			}
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/document/customer/", surtyDocs, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	createSupplierContract(context, contract_data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/supplier/contracts/", contract_data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

    updateSupplierContract(context,contract_data) {
        console.log("contract_data: "+contract_data.data)
		return new Promise((resolve, reject) => {
			Vue.http
				.put("api/supplier/contracts/"+ contract_data.contract_id +"/",contract_data.data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	saveContractDocs(context, contract_docs) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/document/contract/", contract_docs, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
						"Content-Type": "multipart/form-data",
					},
				})
				.then((resp) => {
					resolve(resp);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSuppliersCustomerContracts(context, ID) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/supplier/contracts/?customerID=" + ID, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSuppliersCustomerContractDetail(context, contract_id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + contract_id, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
					// context.commit("setSuppliersCustomerFirstName", response.body.first_name)
					// context.commit("setSuppliersCustomerLastName", response.body.last_name)
					// localStorage.setItem("suppliersCustomerFirstName", response.body.first_name)
					// localStorage.setItem("suppliersCustomerLastName", response.body.last_name)
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	// eslint-disable-next-line no-unused-vars
	getSuppliersContracts(context,info) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("api/supplier/contracts/?page="+info.pageIndex+"&page_size="+info.pageSize, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getSuppliersCustomerInstalments(context, contract_id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + contract_id + "/instalments", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getSuppliersCustomerPayments(context, contract_id) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("contract/data/" + contract_id + "/payments", {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	supplierCalculator(context, data) {
		return new Promise((resolve, reject) => {
			Vue.http
				.post("api/supplier/calculator", data, {
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	downloadContractReport(context,ids)
	{
		console.log("all of ids are: "+JSON.stringify(ids))
		return new Promise((resolve, reject) => {
			Vue.http
				.post("https://faramiran.com/contract/receive_contract",{contr:ids}, {
					responseType: "arraybuffer",
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	getSupplierClearReciept(context, clear_reciept) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("https://faramiran.com/" + clear_reciept, {
					responseType: "arraybuffer",
					headers: {
						Authorization: "Bearer " + localStorage.getItem("customer_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getFinalContract(context, final_c) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("https://faramiran.com/" + final_c, {
					responseType: "arraybuffer",
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSupplierContract(context, supp_c) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("https://faramiran.com/" + supp_c, {
					responseType: "arraybuffer",
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getSupplierCustomerContract(context, cust_c) {
		return new Promise((resolve, reject) => {
			Vue.http
				.get("https://faramiran.com/" + cust_c, {
					responseType: "arraybuffer",
					headers: {
						Authorization: "Bearer " + localStorage.getItem("supplier_token"),
					},
				})
				.then((response) => {
					resolve(response);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	supplierLogOut(context) {
		return new Promise((resolve) => {
			context.commit("supplierLogout");
			localStorage.removeItem("supplier_token");
			// localStorage.removeItem('first_name')
			// localStorage.removeItem('last_name')
			// localStorage.removeItem('first_surety_ID')
			// localStorage.removeItem('second_surety_ID')
			//localStorage.removeItem('customer_id')
			// localStorage.removeItem('mobile_number')
			localStorage.removeItem("supplier_name");

			localStorage.removeItem("suppliersCustomerFirstSuretyID");
			localStorage.removeItem("suppliersCustomerSecondSuretyID");

			localStorage.removeItem("suppliersCustomerFirstName");
			localStorage.removeItem("suppliersCustomerLastName");

			delete Vue.http.headers.common["Authorization"];

			resolve(status.HTTP_200_OK);
		});
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
};
